function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustbd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "33px",
    viewBox: "0 0 30 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(23.921569%,73.333335%,26.274511%)",
      fillOpacity: 1,
      strokeWidth: 0.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(9.803922%,11.372549%,12.54902%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 13.000001 1.00142 L 1.002083 4.999999 L 1.002083 16.999285 C 1.002083 23.629255 6.371355 28.998572 13.000001 28.998572 C 19.628648 28.998572 24.997919 23.629255 24.997919 16.999285 L 24.997919 4.999999 Z M 22.750003 16.999285 C 22.750003 22.382806 18.3862 26.747152 13.000001 26.747152 C 7.613803 26.747152 3.25 22.382806 3.25 16.999285 L 3.25 6.686788 L 13.000001 3.25284 L 22.750003 6.686788 Z M 22.750003 16.999285 ",
    transform: "matrix(1.153846,0,0,1.1,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(23.921569%,73.333335%,26.274511%)",
      fillOpacity: 1,
      strokeWidth: 0.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(9.803922%,11.372549%,12.54902%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 8.825782 13.849428 C 8.720834 13.739343 8.598959 13.661218 8.460157 13.600849 C 8.324741 13.547582 8.175782 13.515621 8.030209 13.515621 C 7.881251 13.515621 7.735678 13.547582 7.600261 13.600849 C 7.464845 13.661218 7.339584 13.739343 7.234636 13.849428 C 7.129688 13.952411 7.045053 14.076701 6.990886 14.208093 C 6.933334 14.346587 6.902865 14.499286 6.902865 14.641331 C 6.902865 14.790479 6.933334 14.936075 6.990886 15.07457 C 7.045053 15.209513 7.129688 15.330252 7.234636 15.440337 L 11.28021 19.481529 L 11.344533 19.545449 C 11.44271 19.644881 11.561199 19.719455 11.689845 19.776273 C 11.818491 19.833091 11.953908 19.857949 12.096095 19.857949 C 12.234897 19.857949 12.373699 19.833091 12.502345 19.776273 C 12.630991 19.719455 12.746095 19.644881 12.847658 19.545449 L 19.831773 12.563917 C 19.92995 12.464485 20.007815 12.347298 20.061981 12.215906 C 20.116148 12.091616 20.143231 11.949571 20.143231 11.811076 C 20.143231 11.672582 20.116148 11.534088 20.061981 11.406247 C 20.007815 11.274855 19.92995 11.157667 19.831773 11.058236 L 19.743752 10.973008 C 19.645575 10.873577 19.530471 10.795452 19.39844 10.742185 C 19.269794 10.688918 19.130992 10.660508 18.99219 10.660508 C 18.853388 10.660508 18.714585 10.688918 18.58594 10.742185 C 18.453908 10.795452 18.338804 10.873577 18.240627 10.973008 L 12.096095 17.116473 Z M 8.825782 13.849428 ",
    transform: "matrix(1.153846,0,0,1.1,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustbd);
export default __webpack_public_path__ + "static/media/trustbd.da53e94dba8dcef839fe85aeec700233.svg";
export { ForwardRef as ReactComponent };